module.exports = __webpack_public_path__ + "static/img/HorizontalGradientLogo-17.cc1a2c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HorizontalGradientLogo-17.png
// module id = T1ls
// module chunks = 1